import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  paymentHistoryList: [],
};

const paymentHistoryCardSlice = createSlice({
  name: 'paymentHistoryCard',
  initialState,
  reducers: {
    setPaymentHistoryCards(state, action) {
      state.paymentHistoryList = action.payload;
    },
  },
});

export const { setPaymentHistoryCards } = paymentHistoryCardSlice.actions;

export default paymentHistoryCardSlice.reducer;
